import { Mapstyles } from './mapstyles';

function onEachFeature(feature, layer) {
  layer.bindTooltip(this.generateTooltip(feature), { direction: 'top', sticky: true });
  layer.on('mouseover', this.mouseOverRegion);
  layer.on('mouseout', this.mouseOutRegion);
  layer.on('click', this.clickRegion);
  layer.setStyle(this.calculateStyle(feature.properties.mapInfos, false));
}

function generateTooltip(feature) {
  let tooltip = '<div class="wb-type-copy tooltip">' + feature.properties.mapInfos.regionDescription + '</div>';

  if (feature.properties.mapInfos.selectedOTARegion && !this.$store.getters.isLivemapSupportEnabled) {
    tooltip += '<div class="wb-type-hint-strong">' + this.$t('overview.otaregion') + '</div>';
  }
  if (feature.properties.mapInfos.upToDate) {
    tooltip +=
      '<div class="wb-type-hint"><span class="wb-type-hint-strong">' +
      this.$t('overview.uptodate') +
      '</span> ' +
      feature.properties.mapInfos.installedMap +
      '</div>';
  } else {
    tooltip +=
      '<div class="wb-type-hint"><span class="wb-type-hint-strong">' +
      this.$t('overview.updateavailable') +
      '</span> ' +
      feature.properties.mapInfos.installedMap +
      ' <wb-icon class="update-chevron-icon" aria-hidden="true" name="chevron-right"></wb-icon> ' +
      feature.properties.mapInfos.availableMap +
      '</div>';
  }
  return tooltip;
}

function mouseOverRegion(e) {
  let mapRegion = e.target.feature.properties.mapInfos;
  this.setSpecificRegionHovered(mapRegion, true);
  e.target.setStyle(this.calculateStyle(mapRegion, true));
}

function mouseOutRegion(e) {
  let mapRegion = e.target.feature.properties.mapInfos;
  this.setSpecificRegionHovered(mapRegion, false);
  e.target.setStyle(this.calculateStyle(mapRegion, false));
}

function calculateStyle(mapRegion, specifiRegionHoverOverrideDefault) {
  let style = {};
  if (mapRegion.upToDate) {
    style =
      this.$store.state.overview.labelUpToDateRegionHovered || specifiRegionHoverOverrideDefault
        ? Mapstyles.upToDate_Hover
        : Mapstyles.upToDate;
  } else {
    style =
      this.$store.state.overview.labelOutdatedRegionHovered || specifiRegionHoverOverrideDefault
        ? Mapstyles.outdated_Hover
        : Mapstyles.outdated;
  }
  if (
    mapRegion.selectedOTARegion &&
    this.$store.getters.isOtaSupportEnabled &&
    !this.$store.getters.isLivemapSupportEnabled
  ) {
    let otaStyle =
      this.$store.state.overview.labelOtaRegionHovered || specifiRegionHoverOverrideDefault
        ? Mapstyles.otaRegion_Hover
        : Mapstyles.otaRegion;
    return Object.assign({}, style, otaStyle);
  }
  return style;
}
export { onEachFeature, generateTooltip, calculateStyle, mouseOverRegion, mouseOutRegion };
